import { V1AreasOfImprovement } from "src/pages/reports/fsci/v1/types";

export const meta: V1AreasOfImprovement = {
    expertiseAndResources: {
        bestPracticeOrientation: {
            title: "Best Practice Orientation",
            prologue:
                "Keeping up with best practices in teaching is prioritized and resources for doing so can be identified.",
        },
        classroomManagement: {
            title: "Classroom Management",
            prologue:
                "Classrooms are seen as providing orderly environments for students, with organized teachers who are consistent with discipline in the classroom.",
        },
        engagedLearning: {
            title: "Engaged Learning",
            prologue:
                "Students engage in activities that nurture critical thinking, evaluating information, and problem solving.",
        },
        qualifiedStaff: {
            title: "Qualified Staff",
            prologue:
                "New teacher hires are credentialed (educationally and licensed/certified) and have classroom experience.",
        },
        resourceConstraint: {
            title: "Resource Constraints",
            prologue: "The school has financial resources to operate effectively.",
        },
        resourcePlanning: {
            title: "Resource Planning",
            prologue:
                "A strategic financial plan and master facilities plan is in place, and financial planning is a strength of the board.",
        },
        resources: {
            title: "Resources",
            prologue:
                "Materials and resources for teaching, including technology, are sufficient, and the school building is in good physical condition.",
        },
        responsivenessToSpecialNeeds: {
            title: "Responsiveness to Special Needs",
            prologue:
                "Teaching staff works together to serve students with special needs, aided by processes for identifying and responding to those needs.",
        },
    },
    learningOrientation: {
        collaboration: {
            title: "Collaboration",
            prologue: "Learning from and with other teachers drives and inspires better teaching.",
        },
        cultureOfImprovement: {
            title: "Culture of Improvement",
            prologue:
                "Guided by school leadership and focused on the future, the school is continually improving/makes necessary changes to improve.",
        },
        dataDrivenImprovement: {
            title: "Data-Driven Improvement",
            prologue:
                "Data is used to gauge school results and effectiveness, determine goal attainment, and address problems the school faces.",
        },
        feedback: {
            title: "Feedback",
            prologue:
                "Feedback on teaching practice and classroom management is given regularly to facilitate adjustments in real-time.",
        },
        individualizedInstruction: {
            title: "Individualized Instruction",
            prologue: "Students are helped to figure out how they learn best and to identify their natural strengths.",
        },
        outcomesFocus: {
            title: "Outcomes Focus",
            prologue:
                "A strong belief is held that process doesn’t matter if it isn’t producing results, and change is distracting if it doesn’t lead to increases in student achievement.",
        },
        professionalDevelopment: {
            title: "Professional Development",
            prologue: "Professional development is provided on-site and is subject- and role-specific.",
        },
        systemsThinking: {
            title: "Systems Thinking",
            prologue:
                "When planning for change, the potential impact on the school, the classroom, students, and the overall system are considered.",
        },
    },
    purpose: {
        godsStory: {
            title: "God's Story",
            prologue:
                "Students believe they are a part of God’s bigger plan and can be used by him to “make a difference.”",
        },
        holisticTeaching: {
            title: "Holistic Teaching",
            prologue:
                "Teachers believe their work intrinsically involves helping students to develop spiritually and emotionally (teaching the heart and the soul, as well as the mind).",
        },
        integratedWorldView: {
            title: "Integrated Worldview",
            prologue:
                "Leadership believes Christian education should be thoroughly shaped by Christian worldview, in every sphere and area of life.",
        },
        partnership: {
            title: "Partnership",
            prologue:
                "Parents feel they are a part of the school’s mission, and that their child’s spiritual development requires their partnering with and being involved at the school.",
        },
        questioning: {
            title: "Questioning",
            prologue:
                "Many students view Christians positively, and are more likely to be spiritually engaged and confident in their faith.",
        },
        responsibility: {
            title: "Responsibility",
            prologue:
                "Leaders, teachers, and support staff feel a sense of shared ownership for school success and improvement in alignment with school mission.",
        },
        spiritualFormation: {
            title: "Spiritual Formation",
            prologue:
                "Alumni report that their Christian faith is stronger thanks to attending a Christian school, and they believe people can change with God’s help.",
        },
    },
    relationships: {
        caringEnvironment: {
            title: "Caring Environment",
            prologue:
                "From the perspective of school graduates, teachers were kind, included students in class, and protected students from bullying.",
        },
        christlikeTeachers: {
            title: "Christlike Teachers",
            prologue:
                "Students and their families report that teachers show Christlike love, kindness, and care. Teachers care about students individually.",
        },
        communityEngagement: {
            title: "Community Engagement",
            prologue:
                "The school engages with the surrounding community and regularly taps into community resources, including networking and resource-sharing with other schools.",
        },
        insularCulture: {
            title: "Insular Culture",
            prologue:
                "The school does not hide its light from the world, or the world from its students, by welcoming students from diverse backgrounds and engaging with the surrounding community.",
        },
        leadershipInterdependence: {
            title: "Leadership Interdependence",
            prologue:
                "Leadership leverages a culture of individual transparency and variety of diverse backgrounds to offset one another's weaknesses.",
        },
        mentoringStudents: {
            title: "Mentoring Students",
            prologue:
                "Staff point out talent in each student, help students see how they fit in God’s bigger plan, and are aware of students’ struggles at school or home.",
        },
        parentRelationships: {
            title: "Parent Relationships",
            prologue:
                "Teachers “get to know” parents through frequent and systemic communication that facilitates positive relationships.",
        },
        prosocialOrientation: {
            title: "Prosocial Orientation",
            prologue:
                "Students not only enjoy helping others, but also are known by others (e.g., peers) for showing love and care.",
        },
        supportiveLeadership: {
            title: "Supportive Leadership",
            prologue:
                "Teachers and support staff trust their principal(s) and feel that school leaders “have our backs.” Leaders empower teachers and staff to make decisions.",
        },
    },
    wellBeing: {
        healthyLiving: {
            title: "Healthy Living",
            prologue:
                "Students are happy with their physical health, including sufficient exercise and a healthy diet.",
        },
        resilience: {
            title: "Resilience",
            prologue:
                "Students feel capable of handling stress, and are able to respond well and work through difficult situations.",
        },
        stress: {
            title: "Stress",
            prologue:
                "Generally speaking, educators at the school are not excessively overwhelmed or stressed; for teachers, adequate time to prepare for instruction may contribute to this positive finding, and having time to focus on physical health may be a positive factor for leaders.",
        },
    },
};
